import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import CancelButton from '../../../../../../components/buttons/CancelButton'
import PrimaryButton from '../../../../../../components/buttons/PrimaryButton'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: '32px 32px 0px 32px',
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeBtn: {
    cursor: 'pointer',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#404040',
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: '28px 32px 0px 32px',
  },
  footerSection: {
    padding: '28px 32px  26px',
  },
  deleteBtn: {
    backgroundColor: '#f74872',
    '&:hover': {
      backgroundColor: '#f74872',
      borderColor: '#f74872',
    },
    '&:focus': {},
  },
}))

export default (props) => {
  const { deleteNote, openOrCloseDeleteDialog } = props
  const styleClass = useStyles()

  const [localState, setLocalState] = useState({
    isDisabledBtn: false,
  })

  const handleDelete = () => {
    deleteNote()
    setLocalState({
      ...localState,
      isDisabledBtn: true,
    })
  }

  return (
    <Dialog
      maxWidth="sm"
      fullWidth={true}
      className={styleClass.dialogWrapper}
      open={true}
    >
      <DialogTitle disableTypography={true} className={styleClass.titleSection}>
        <div className={styleClass.titleWrapper}>
          <div className={styleClass.title}>
            <FormattedMessage id="note.delete.title" />
          </div>
          <div
            className={styleClass.closeBtn}
            onClick={openOrCloseDeleteDialog}
          >
            <CloseIcon />
          </div>
        </div>
      </DialogTitle>

      <DialogContent className={styleClass.contentSection}>
        <FormattedMessage id="note.delete.content" />
      </DialogContent>

      <DialogActions className={styleClass.footerSection}>
        <CancelButton
          className={styleClass.actionBtn}
          onClick={openOrCloseDeleteDialog}
        >
          <FormattedMessage id="action.cancel" />
        </CancelButton>

        <PrimaryButton
          disabled={localState.isDisabledBtn}
          onClick={handleDelete}
          className={styleClass.deleteBtn}
        >
          <FormattedMessage id="action.delete" />
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  )
}
